import React, { useEffect, useState } from "react";
import {
    Box,
    Container,
    Grid,
    makeStyles,
    TextField,
    Button,
} from "@material-ui/core";
import Page from "../../../../components/Page";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import Title from "../../../../components/Title";
import { getCategoria, updateFlorCategoria } from "../../../../database/API";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
    },
    container: {
        paddingTop: 47,
    },
    "@global": {
        html: {
            width: "100%",
            height: "100%",
        },
    },
    formControl: {
        marginTop: 16,
        marginBottom: 15,
    },
}));

const CategoriesView = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { key } = useParams();
    const [categoria, setCategoria] = useState();

    useEffect(() => {
        console.log(key);
        const get = async () => {
            const { categoria } = await getCategoria(key);
            console.log(categoria);
            setCategoria(categoria);
        };
        get();
    }, [key]);

    const crear = async (values) => {
        const message = await updateFlorCategoria(values, key);
        enqueueSnackbar(message, {
            variant: "success",
        });
        navigate(-1, { state: values });
    };

    return (
        <Page className={classes.root} title={"Dashboard"}>
            <Container maxWidth={false} className={classes.container}>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        nom: categoria?.nom,
                        descripcio: categoria?.descripcio,
                    }}
                    validationSchema={Yup.object().shape({
                        nom: Yup.string().required("El nom és obligatòri"),
                        descripcio: Yup.string().required(
                            "La descripcio és obligatòria"
                        ),
                    })}
                    onSubmit={(values) => {
                        crear(values);
                    }}
                >
                    {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        touched,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mb={3}>
                                <Title
                                    title={"Editar categoria"}
                                    subtitle={
                                        "Entra les dades per guardar una nova categoria de flor"
                                    }
                                />
                            </Box>
                            <Grid container spacing={3}>
                                <Grid item md={12}>
                                    <TextField
                                        error={Boolean(
                                            touched.nom && errors.nom
                                        )}
                                        fullWidth
                                        helperText={touched.nom && errors.nom}
                                        label="Nom"
                                        margin="normal"
                                        name="nom"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="text"
                                        variant="outlined"
                                        value={values.nom}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Box my={2}>
                                <Button
                                    color="primary"
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                >
                                    {"Guardar"}
                                </Button>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container>
        </Page>
    );
};

export default CategoriesView;
